"use strict";

exports.__esModule = true;
var getValueForProgressBar = exports.getValueForProgressBar = function getValueForProgressBar(fullReviewsCount, singleStarCount) {
  return (singleStarCount * 100 / fullReviewsCount).toFixed(2);
};


// WEBPACK FOOTER //
// ./components/profile-right-section/lib/utils/utils.js